import { State, Action, StateContext, createPropertySelectors } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';

import { IAuthStateModel } from './auth.models';
import { AuthService } from './auth.service';
import { authStateDefaults } from './auth.utils';
import { FetchAuthentication, FetchAuthorization } from './auth.actions';

@Injectable()
@State<IAuthStateModel>({
    name: authStateDefaults.sliceName,
    defaults: authStateDefaults.defaults
})
export class AuthState {
    public static selectors = createPropertySelectors<IAuthStateModel>(AuthState);

    private _authService = inject(AuthService);

    @Action(FetchAuthorization)
    private _fetchAuthorization(ctx: StateContext<IAuthStateModel>) {
        return this._authService.getAuthorizationApi().pipe(
            map(authorization => {
                return ctx.patchState({
                    authorization
                });
            })
        );
    }

    @Action(FetchAuthentication)
    private _fetchAuthentication(ctx: StateContext<IAuthStateModel>) {
        return this._authService.getAuthenticationApi().pipe(
            map(authentication => {
                return ctx.patchState({
                    authentication
                });
            })
        );
    }
}
